/* ==========================================================================
   Haalora — beweging en interactie
   Drie kleine onderdelen: scroll-reveal, carrousel en het interactieve
   stappenplan. Geen libraries. Alles werkt ook zonder JavaScript: dan staat
   de inhoud gewoon zichtbaar en is de carrousel een swipebare rij.
   ========================================================================== */

(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  /* ------------------------------------------------------------- reveal */

  var revealObserver = null;

  function initReveal(scope) {
    if (reduced || !('IntersectionObserver' in window)) return;

    document.documentElement.classList.add('hx-js');

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          each(entries, function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
      );
    }

    each((scope || document).querySelectorAll('[data-hx-reveal]:not(.is-in)'), function (node, index) {
      if (!node.style.getPropertyValue('--hx-delay')) {
        node.style.setProperty('--hx-delay', Math.min(index, 3) * 70 + 'ms');
      }
      if (node.getBoundingClientRect().top < window.innerHeight * 0.92) {
        node.classList.add('is-in');
        return;
      }
      revealObserver.observe(node);
    });
  }

  /* ---------------------------------------------------------- carrousel */

  function initCarousel(root) {
    if (root.dataset.hxReady === 'true') return;
    root.dataset.hxReady = 'true';

    var viewport = root.querySelector('[data-hx-viewport]');
    if (!viewport) return;

    var prev = root.querySelector('[data-hx-prev]');
    var next = root.querySelector('[data-hx-next]');
    var items = root.querySelectorAll('[data-hx-item]');
    if (!items.length) return;

    function step() {
      var first = items[0];
      var second = items[1];
      if (second) return second.offsetLeft - first.offsetLeft;
      return first.getBoundingClientRect().width;
    }

    function syncButtons() {
      if (!prev || !next) return;
      var max = viewport.scrollWidth - viewport.clientWidth - 2;
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= max;
    }

    function go(direction) {
      viewport.scrollBy({ left: step() * direction, behavior: reduced ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); stop(); });
    if (next) next.addEventListener('click', function () { go(1); stop(); });

    viewport.addEventListener('scroll', function () {
      window.clearTimeout(viewport._hxTimer);
      viewport._hxTimer = window.setTimeout(syncButtons, 90);
    }, { passive: true });

    window.addEventListener('resize', syncButtons, { passive: true });

    // Toetsenbord: de viewport is focusbaar, pijltjes verspringen één kaart.
    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); go(1); stop(); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(-1); stop(); }
    });

    /* Autoplay — optioneel, stopt bij hover, focus, swipe of verborgen tab. */
    var timer = null;
    var interval = parseInt(root.dataset.hxAutoplay, 10) || 0;

    function tick() {
      var max = viewport.scrollWidth - viewport.clientWidth - 2;
      if (viewport.scrollLeft >= max) {
        viewport.scrollTo({ left: 0, behavior: reduced ? 'auto' : 'smooth' });
      } else {
        go(1);
      }
    }

    function start() {
      if (!interval || reduced || document.hidden) return;
      stop();
      timer = window.setInterval(tick, interval * 1000);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    if (interval && !reduced) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      viewport.addEventListener('touchstart', stop, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });
      start();
    }

    syncButtons();
  }

  /* ------------------------------------------------- interactief stappenplan */

  function initFlow(root) {
    if (root.dataset.hxReady === 'true') return;
    root.dataset.hxReady = 'true';

    var steps = root.querySelectorAll('[data-hx-step]');
    var frames = root.querySelectorAll('[data-hx-frame]');
    if (steps.length < 2) return;

    function activate(index) {
      each(steps, function (step, i) {
        step.classList.toggle('is-active', i === index);
      });
      each(frames, function (frame, i) {
        var on = i === index;
        frame.classList.toggle('is-active', on);
        var video = frame.querySelector('video');
        if (video) {
          if (on && typeof video.play === 'function') {
            var playing = video.play();
            if (playing && typeof playing.catch === 'function') playing.catch(function () {});
          } else if (!on && typeof video.pause === 'function') {
            video.pause();
          }
        }
      });
    }

    each(steps, function (step, index) {
      step.addEventListener('mouseenter', function () { activate(index); });
      step.addEventListener('focusin', function () { activate(index); });
      var trigger = step.querySelector('button');
      if (trigger) trigger.addEventListener('click', function () { activate(index); });
    });

    activate(0);
  }

  /* -------------------------------------------------------- init runner */

  function init(scope) {
    try {
      initReveal(scope);
      each((scope || document).querySelectorAll('[data-hx-carousel]'), initCarousel);
      each((scope || document).querySelectorAll('[data-hx-flow]'), initFlow);
    } catch (error) {
      each(document.querySelectorAll('[data-hx-reveal]'), function (n) { n.classList.add('is-in'); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
